
import React from 'react';
import type { GeminiAnalysisResponse, OptimizedResume } from '../types';
import AnalysisSidebar from './AnalysisSidebar';
import ResumePreview from './ResumePreview';
import { ArrowLeftIcon } from './icons/ArrowLeftIcon';
import { DownloadIcon } from './icons/DownloadIcon';

interface ResultsScreenProps {
  analysisResult: GeminiAnalysisResponse;
  editedResume: OptimizedResume;
  onResumeChange: (updatedResume: OptimizedResume) => void;
  onReset: () => void;
}

const ResultsScreen: React.FC<ResultsScreenProps> = ({ analysisResult, editedResume, onResumeChange, onReset }) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="flex flex-col lg:flex-row gap-8">
        <div id="sidebar" className="lg:w-1/3 xl:w-1/4 lg:sticky lg:top-24 self-start">
            <AnalysisSidebar analysis={analysisResult.analysis} />
        </div>
        
        <div className="flex-grow">
            <div id="controls" className="flex items-center justify-between mb-4 bg-white/60 backdrop-blur-md p-3 rounded-lg border border-slate-200 sticky top-24 z-10">
                <button
                    onClick={onReset}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-md hover:bg-slate-50 transition-colors"
                >
                    <ArrowLeftIcon className="w-4 h-4" />
                    Start Over
                </button>
                <h2 className="hidden md:block text-lg font-semibold text-slate-800">Your Transformed Resume</h2>
                <button
                    onClick={handlePrint}
                    className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 transition-colors"
                >
                    <DownloadIcon className="w-4 h-4" />
                    Download PDF
                </button>
            </div>
            <div id="resume-preview-container" className="lg:p-8 bg-white rounded-lg border border-slate-200 shadow-sm">
                 <ResumePreview resume={editedResume} onResumeChange={onResumeChange} />
            </div>
        </div>
    </div>
  );
};

export default ResultsScreen;
